import { render } from "./ResumeModalSendGroupMessage.vue?vue&type=template&id=3acd566a"
import script from "./ResumeModalSendGroupMessage.vue?vue&type=script&lang=js"
export * from "./ResumeModalSendGroupMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__